export default __webpack_public_path__ + "static/media/55.35d723bd.jpeg";